export default __webpack_public_path__ + "static/media/openNewTab.cd6b649f.svg";